module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#magazines",
      toString: function () {
        return this.url;
      }
    }